import { useDispatch, useSelector } from "react-redux";
import {
  updateBookingDetails,
  updateBookingListData,
  updateCustomerDetails,
  updateDisplayDate,
  updateDisplayDOB,
  updateGuestSectionVisible,
  updateShowPrimaryGuestDrawer,
} from "../../reducer/bookingReducer";
import { useEffect } from "react";
import { updateBookingListData as updateReservationCalendarBookingListData } from "../../reducer/bookingReservationReducer";

import {
  customerDetailsById,
  customerDetailsByPhone,
  postCustomer,
  putCustomer,
} from "../../services/customer";
import { DEBBOUNCING_TIME } from "../../utils/helper";
import { message } from "antd";

const useAddPrimaryGuest = (
  customerData,
  setCustomerData,
  setCustomerDataLoading,
  setLoading,
  displayDate,
  displayDOB,
  setFetchedName,
  fetchedName
) => {
  const dispatch = useDispatch();

  const { hotelDetails } = useSelector((store) => store.login);

  const {
    showPrimaryGuestDrawer,
    showMainBookingDetailsDrawer,
    bookingDetails,
    response,
    bookingHotelId,
    invoiceDetails,
    customerDetails,
    guestSectionVisible,
  } = useSelector((store) => store.booking);

  useEffect(() => {
    if (showPrimaryGuestDrawer?.customerType === "existing") performApi();
  }, [guestSectionVisible, showPrimaryGuestDrawer, bookingHotelId]);

  useEffect(() => {
    if(showPrimaryGuestDrawer && showPrimaryGuestDrawer?.customerType
      && showPrimaryGuestDrawer?.customerType === "existing"){
        return;
      }
    let getData = null;
    let phoneNumber = customerData?.contactDetails?.phoneNumber;

    getData = setTimeout(() => {
      let phoneLength = Boolean(phoneNumber)
        ? phoneNumber?.toString()?.length
        : 0;

      if (phoneLength >= 7) {
        fetchCustomerDetails();
      }
    }, DEBBOUNCING_TIME);

    return () => clearTimeout(getData);
  }, [customerData?.contactDetails?.phoneNumber, showPrimaryGuestDrawer]);

  const fetchCustomerDetails = async () => {
    // if phone number is same, then no need to call the API again
    if (
      customerData?.contactDetails?.phoneNumber ===
      customerData?.originalPhoneNumber
    )
      return;

    let payload = {
      hotelId: bookingHotelId,
      phone: customerData?.contactDetails?.phoneNumber,
      countryCode: customerData?.contactDetails?.countryCode,
    };

    let response = await customerDetailsByPhone(payload);
    const data = response?.data?.customer;

    if (Boolean(data)) {
      fillCustomerData(data);
    } else {
      // setCustomerData({});
    }
  };

  const performApi = async () => {
    setCustomerDataLoading(true);

    const roomBillInvoiceId = invoiceDetails?.find(
      ({ invoiceType }) => invoiceType == "roomBill"
    )?.id;

    const payload = {
      hotelId: bookingHotelId,
      id: showPrimaryGuestDrawer?.customerId,
      invoiceId: roomBillInvoiceId,
    };
    const { data } = await customerDetailsById(payload);
    fillCustomerData(data);
  };

  const fillCustomerData = (data) => {
    let updatedCustData = {
      ...data,
      originalPhoneNumber: data?.contactDetails?.phoneNumber,
      contactDetails: {
        ...data.contactDetails,
        phoneValue:
          data?.contactDetails?.countryCode + data?.contactDetails?.phoneNumber,
      },
    };
    setCustomerData(updatedCustData);
    setFetchedName(data?.name);
    setCustomerDataLoading(false);
  };

  const handleSave = async () => {
    if (!isValid()) return;

    setLoading(true);

    try {
      let data;
      const invoiceIds = invoiceDetails?.map(({ id }) => id);
      let customerDataRequest = JSON.parse(JSON.stringify(customerData));
      customerDataRequest['phone'] = customerData?.contactDetails?.phoneValue;
      if (customerData?.id) {
        // Edit existing primary guest
        data = await putCustomer({ ...customerDataRequest, invoiceIds });

        let updatedCustomerDetails = customerDetails?.map((Obj) =>
          Obj?.id === data?.id ? data : Obj
        );

        dispatch(updateCustomerDetails(updatedCustomerDetails));

        const newResponse = JSON.parse(JSON.stringify(response));
        const index = newResponse?.customers?.findIndex(
          (Obj) => Obj.id === data.id
        );

        const bookingIndex = newResponse?.bookings?.findIndex(
          (Obj) => Obj.bookingId === bookingDetails?.bookingId
        );

        const currentPrimaryGuestName =
          newResponse?.bookings?.[bookingIndex]?.["primaryGuestName"] || "";

        if (fetchedName === currentPrimaryGuestName) {
          newResponse.bookings[bookingIndex]["primaryGuestName"] = data?.name;
          newResponse.bookings[bookingIndex]["primaryGuestPhoneNumber"] =
            data?.phone;
          setFetchedName(data?.name);
        }

        newResponse.customers[index] = data;

        await dispatch(updateBookingListData(newResponse));
        await dispatch(updateReservationCalendarBookingListData(newResponse));

        message.success("Data Successfully Edited");
      } else {
        // Add new primary guest
        const payload = {
          ...customerData,
          hotelId: hotelDetails?.id,
        };

        data = await postCustomer(payload);

        if (Boolean(data?.id)) {
          data = await putCustomer({ ...data, invoiceIds });

          const newPrimaryGuestId = data?.id;
          const newBookingDetails = JSON.parse(JSON.stringify(bookingDetails));
          newBookingDetails?.guests.push(newPrimaryGuestId);

          const updatedCustomerDetails = [...customerDetails, data];

          await dispatch(updateBookingDetails(newBookingDetails));
          await dispatch(updateCustomerDetails(updatedCustomerDetails));

          message.success("Data Successfully Updated");
        } else {
          message.error("Something Went Wrong");
          return;
        }
      }
    } catch (error) {
      message.error("An error occurred. Please try again.");
    } finally {
      setLoading(false);
      handleClose();
    }
  };

  const isValid = () => {
    message.destroy();

    let phoneNumber = customerData?.contactDetails?.phoneNumber;
    let name = customerData?.name;

    if (!Boolean(phoneNumber)) {
      message.error("Please enter customer number");
      return false;
    } else if (!Boolean(name)) {
      message.error("Please enter customer name!");
      return false;
    } else return true;
  };

  const handleClose = () => {
    setCustomerData({});
    setFetchedName("");
    dispatch(updateDisplayDOB(false));
    dispatch(updateDisplayDate(false));

    dispatch(updateGuestSectionVisible(false));

    dispatch(
      updateShowPrimaryGuestDrawer({
        visible: false,
        bookingId: showMainBookingDetailsDrawer.bookingId,
        customerType: "",
      })
    );
  };

  const handleCustomerDataFieldChange = (field, value) => {
    setCustomerData((prev) => {
      return {
        ...prev,
        [field]: value,
      };
    });
  };

  const handleDateState = () => {
    if (displayDate) {
      dispatch(updateDisplayDate(null));
    }
    if (displayDOB) {
      dispatch(updateDisplayDOB(false));
    }
  };

  return {
    handleSave,
    handleClose,
    handleCustomerDataFieldChange,
    handleDateState,
  };
};

export default useAddPrimaryGuest;
